import styled from '@emotion/styled'

/**
 * 페이지 최상단 스크롤 floating 버튼.
 *
 * 시각 디자인(원형 배경, 그림자, 화살표)은 모두 `top-button.svg` 한 장에 포함.
 * 본 styled button 은 fixed positioning + fade transition 만 담당.
 *
 * - 우하단 fixed, safe-bottom 고려
 * - 200ms fade in/out
 * - SVG viewBox 56×56 (외곽 4px 그림자 영역 포함) — 시각적 원은 48×48
 */
export const FloatingButton = styled.button`
  position: fixed;
  right: 16px;
  bottom: calc(16px + var(--safe-bottom, 0px));
  z-index: 50;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
  transition:
    opacity 200ms ease-out,
    visibility 200ms ease-out,
    transform 200ms ease-out;

  &[data-visible='true'] {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  &:active {
    opacity: 0.85;
  }
`
